import { render } from "./MessageField.vue?vue&type=template&id=2d10fc34&scoped=true"
import script from "./MessageField.vue?vue&type=script&lang=js"
export * from "./MessageField.vue?vue&type=script&lang=js"

import "./MessageField.vue?vue&type=style&index=0&id=2d10fc34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d10fc34"]])

export default __exports__